import { useRouteError } from 'react-router-dom';
import ErrorFallbackScreen from '@/components/common/ErrorFallbackScreen';

export default function RouteErrorFallback() {
  const error = useRouteError();
  console.error('Route error:', error);

  // Recharge la page en cours : renvoyer à la racine éjectait le spectateur vers la
  // connexion, sans moyen de revenir à son live sans son lien d'accès.
  return <ErrorFallbackScreen onRetry={() => window.location.reload()} />;
}
